import { render } from "./PrescriptionPrint.vue?vue&type=template&id=5c2280e4&scoped=true"
import script from "./PrescriptionPrint.vue?vue&type=script&lang=js"
export * from "./PrescriptionPrint.vue?vue&type=script&lang=js"

import "./PrescriptionPrint.vue?vue&type=style&index=0&id=5c2280e4&scoped=true&lang=css"

import exportComponent from "C:\\work\\HIMSDeployTest\\HIMSFRONTEND\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c2280e4"]])

export default __exports__